module.exports = __webpack_public_path__ + "static/6-Things-to-Know-Before-Your-Appointment-e233c3499392b070251e4fe2405dc809.webp";